import { ResourceDescriptionBase } from './ResourceDescriptionBase';
import { ResourcePackage } from './ResourcePackage';
import { ResourceBase } from './Resource';
import { ResourcePool } from './ResourcePool';
import { EventStream } from './EventStreamSubscription';

export const T_ResourceCache = Symbol('ResourceCache');

export interface IResourceCache {
  getResource<T extends ResourceBase>(resourceType: string, resourceId: string): T | null;
  loadPackage(url: string): Promise<ResourcePackage>;
  unloadPackage(pack: ResourcePackage): void;
}

export interface IConcreteResourceCache extends IResourceCache {
  loadPackageFromXML(xml: Element): Promise<ResourcePackage>;
  loadPackageFile(zipFile: File): Promise<ResourcePackage>;
  loadTextureResource(resourceType: string, description: ResourceDescriptionBase): Promise<void>;
  registerPool(resourceTypeId: string, pool: ResourcePool<ResourceBase>): void;
  unloadResource(resource: ResourceBase): void;
  contextLost(): void;
  contextReady(): Promise<void>;
  get enableMediaHack(): boolean;
  set enableMediaHack(value: boolean);
  getPool(name: string): ResourcePool<ResourceBase> | null;
  beforeLoad: EventStream<string>;
}
